/**
 * De aftelbalk bovenin: laat zien hoe lang het rooster nog in beeld blijft.
 *
 * Een dunne balk over de volle breedte die leegloopt. Het is een CSS-animatie met
 * de duur als variabele — de app rendert maar één keer per seconde, en een balk
 * die in stapjes verspringt leest als haperen.
 *
 * De animatie begint als dit component verschijnt. App.tsx toont het alleen
 * zolang de uitlogtimer loopt, dus bij inloggen en na het sluiten van het
 * demo-paneel beginnen de timer en de balk samen opnieuw.
 */
import type { CSSProperties } from 'react';

export function UitlogBalk({ duurMs }: { duurMs: number }) {
  const seconden = Math.round(duurMs / 1000);
  const stijl = { '--uitlog-duur': `${duurMs}ms` } as CSSProperties;

  return (
    <div
      className="uitlog-balk"
      style={stijl}
      role="timer"
      aria-label={`Je wordt na ${seconden} seconden automatisch uitgelogd`}
    />
  );
}
